module.exports = __webpack_public_path__ + "img/3.5baf7562.jpeg";